import { render, staticRenderFns } from "./payAddPayee.vue?vue&type=template&id=55bd2215&scoped=true&"
import script from "./payAddPayee.vue?vue&type=script&lang=js&"
export * from "./payAddPayee.vue?vue&type=script&lang=js&"
import style0 from "./payAddPayee.vue?vue&type=style&index=0&id=55bd2215&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bd2215",
  null
  
)

export default component.exports